// Define the Splide configuration object
const splideConfig = {
  perPage: 4,
  focus  : 0,
  omitEnd: true,
  perMove: 1,
  gap: '32px',
  pagination: false, // Set these to false initially
  arrows: false,     // We'll control them via overflow
  drag: false,      
  breakpoints: {
    1920: {
      perPage: 4,
      perMove: 1,
      gap: '32px',
      padding: { right: '0px' },
  },
      1120: {
          perPage: 2,
          perMove: 1,
          start  : 0,
          gap: '32px',
          padding: { right: '12.4rem' },
      },
      767: {
          perPage: 1,
          perMove: 1,
          gap: '20px',
          padding: { right: '20%' },
      },
      430: {
          perPage: 1,
          perMove: 1,
          gap: '20px',
          padding: { right: '30%' },
      },
  },
};

// Function to initialize Splide
function initSplide() {
  const splide = new Splide('#best-sellers-hover', splideConfig);
  
  // Add overflow event handler
  splide.on('overflow', function(isOverflow) {
      const options = {
          arrows: isOverflow,
          pagination: isOverflow,
          drag: isOverflow
      };
      
      // Update the slider options
      splide.options = {...splide.options, ...options};
      
      // Refresh the slider to apply changes
      if (splide.initialized) {
          splide.refresh();
      }
  });
  
  splide.mount();
}

// Add event listeners
document.addEventListener('DOMContentLoaded', initSplide);
document.addEventListener('shopify:section:load', initSplide);